/**
 * /tenants/$slug/agents/guide — redirect to the merged front door.
 *
 * This route used to mount agents-guide-page.tsx ("Agent overview"). That page was absorbed
 * into features/nhi-overview on 2026-08-16: its three routing questions were cut, its eight
 * "start from what you have" rows and its proof paths moved, and the place stopped carrying
 * two non-actionable explainer entries three rail rows apart.
 *
 * THE ROUTE SURVIVES AS A REDIRECT because eight links inside the console point at it, plus
 * whatever bookmarks customers hold. Deleting it would 404 them all. The per-kind explainers
 * at /agents/guide/$type are unaffected and keep their own routes.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/guide")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/tenants/$slug/non-human-identities/overview",
      params: { slug: params.slug },
      replace: true,
    });
  },
});
